module.exports = __webpack_public_path__ + "img/mosaico-azul.abdb837b.png";